import { UserService } from '../../../../shared/services/user.service';
import { AuthService } from '../../../../shared/services/auth.service';
import { environment } from 'environments/environment';
var LogoComponent = (function () {
    function LogoComponent(userService, auth) {
        var _this = this;
        this.userService = userService;
        this.auth = auth;
        this.showB2ALogo = false;
        this.isLoggedIn = false;
        this.backend = '';
        this.timestamp = 0;
        userService.currentUser.subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.user = user;
            _this.showB2ALogo = false;
        });
        this.backend = environment.backendUrl;
        this.timestamp = Date.now();
        auth.loggedIn.subscribe(function (value) { return (_this.isLoggedIn = value); });
    }
    LogoComponent.prototype.ngOnInit = function () { };
    return LogoComponent;
}());
export { LogoComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/components/logo/logo.component.ts.pre-build-optimizer.js